import { colors } from "./colors";

export const borders = {
  "border-style-1": `1px solid ${colors["neutral-100-alpha"]}`,
};
